
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { ArgsTable, Canvas, Meta, Story } from '@storybook/addon-docs';
import { shuffle } from 'lodash';
import avatarsDemo from './demo/avatars.twig';
const demoImageDir = require.context('./demo', false, /\.png$/);
const demoImageSrcs = demoImageDir.keys().map((key) => demoImageDir(key));
const avatarsDemoStory = (args) => {
  const srcs = shuffle(demoImageSrcs).slice(0, args.count);
  return avatarsDemo({ srcs });
};
// The story demo is kind of specific to Storybook, so we're manually defining
// a source code example that will be easier to understand.
const avatarsDemoSrc = `{% embed '@cloudfour/objects/bunch/bunch.twig' only %}
  {% block content %}
    {# avatars #}
  {% endblock %}
{% endembed %}`;


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/Bunch" args={{
      count: 3
    }} argTypes={{
      count: {
        type: 'number',
        description: 'Number of avatars to show',
        control: {
          type: 'range',
          min: 1,
          max: demoImageSrcs.length,
          step: 1
        }
      }
    }} mdxType="Meta" />
    <h1>{`Bunch`}</h1>
    <p>{`A tight cluster of visual elements with a small amount of overlap. Useful for displaying `}<a parentName="p" {...{
        "href": "/docs/components-avatar--empty"
      }}>{`avatars`}</a>{` alongside bylines where multiple authors are equally credited.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Of avatars" parameters={{
        docs: {
          source: {
            code: avatarsDemoSrc
          }
        }
      }} mdxType="Story">
    {avatarsDemoStory.bind({})}
  </Story>
    </Canvas>
    <ArgsTable story="Of avatars" mdxType="ArgsTable" />
    <h2>{`CSS Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`--bunch-index`}</inlineCode>{` (on children): The higher this number, the lower the element's `}<inlineCode parentName="li">{`z-index`}</inlineCode>{`. Applied automatically to the first ten child elements. May become unnecessary someday if we get `}<a parentName="li" {...{
          "href": "https://github.com/w3c/csswg-drafts/issues/1026#issuecomment-385285148"
        }}>{`CSS support for reversing stack order`}</a>{`.`}</li>
    </ul>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`class`}</inlineCode>{`: Append a class to the `}<inlineCode parentName="li">{`o-block`}</inlineCode>{` element.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`content`}</inlineCode>{` (block): Directly specify content for the element.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const ofAvatars = avatarsDemoStory.bind({});
ofAvatars.storyName = 'Of avatars';
ofAvatars.parameters = { storySource: { source: 'avatarsDemoStory.bind({})' }, ...{
  docs: {
    source: {
      code: avatarsDemoSrc
    }
  }
} };

const componentMeta = { title: 'Objects/Bunch', args: {
  count: 3
}, argTypes: {
  count: {
    type: 'number',
    description: 'Number of avatars to show',
    control: {
      type: 'range',
      min: 1,
      max: demoImageSrcs.length,
      step: 1
    }
  }
}, includeStories: ["ofAvatars"],  };

const mdxStoryNameToKey = {"Of avatars":"ofAvatars"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;